import axios from "axios";
import { API } from "../config";

axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.put["Access-Control-Allow-Origin"] = "*";

const path = "/servico-acolhimento";

class ServicoAcolhimentoService {
  novoServicoAcolhimento(servicosAcolhimento) {
    var formData = new FormData();

    for (let key in servicosAcolhimento) {
      if (!(key === "logomarca" && servicosAcolhimento[key] === null)) {
        formData.append(key, servicosAcolhimento[key]);
      }
    }

    return axios.post(API + path, formData);
  }

  postFamiliaAcolhedora(idServicosAcolhimento, familiaAcolhedoraRequestDTO) {
    return axios.post(
      API + path + `/${idServicosAcolhimento}/familia-acolhedora/acolhedor`,
      familiaAcolhedoraRequestDTO,
    );
  }

  postValidCNPJ(cnpj, idServicosAcolhimento) {
    return axios.post(
      API +
        path +
        `/validar-cnpj?cnpj=${cnpj}&idServicoAcolhimento=${idServicosAcolhimento}`,
    );
  }

  listarServicosAcolhimento() {
    return axios.get(API + path);
  }

  listarServicosAcolhimentoSoAtivos() {
    return axios.get(API + path + "/ativos");
  }

  listarServicosAcolhimentoAtivos() {
    return axios.get(API + "/servico-acolhimento/ativos-suspensos");
  }

  getServicoAcolhimento(id) {
    return axios.get(API + path + "/" + id);
  }

  editarServicoAcolhimento(id, servicosAcolhimento) {
    var formData = new FormData();

    for (let key in servicosAcolhimento) {
      if (!(key === "logomarca" && servicosAcolhimento[key] === null)) {
        formData.append(key, servicosAcolhimento[key]);
      }
    }

    return axios.put(API + path + `/${id}`, formData);
  }

  pesquisarServicosAcolhimento(filters) {
    const {
      nomeFantasia,
      promotoriaId,
      varaInfanciaId,
      estadoId,
      estados,
      municipioId,
      municipios,
      bairroId,
      bairros,
      status,
      naturezaServico,
      regime,
      modalidade,
      razaoSocial,
    } = filters;

    return axios.get(API + path + "/pesquisar", {
      params: {
        nomeFantasia: nomeFantasia !== "" ? nomeFantasia : undefined,
        promotoriaId: promotoriaId !== "" ? promotoriaId : undefined,
        varaInfanciaId: varaInfanciaId !== "" ? varaInfanciaId : undefined,
        estadoId: estadoId !== "" ? estadoId : undefined,
        municipioId: municipioId !== "" ? municipioId : undefined,
        bairroId: bairroId !== "" ? bairroId : undefined,
        status: status !== "" ? status : undefined,
        naturezaServico: naturezaServico !== "" ? naturezaServico : undefined,
        regime: regime !== "" ? regime : undefined,
        modalidade: modalidade !== "" ? modalidade : undefined,
        razaoSocial: razaoSocial !== "" ? razaoSocial : undefined,
        municipios: municipios !== "" ? municipios : undefined,
        bairros: bairros !== "" ? bairros : undefined,
        estados: estados !== "" ? estados : undefined,
      },
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, v));
          } else if (value !== undefined && value !== null) {
            searchParams.append(key, value);
          }
        });
        return searchParams.toString();
      },
    });
  }

  pesquisarServicosAcolhimentoDashboard() {
    return axios.get(API + path + "/pesquisar-dashboard");
  }

  pesquisarServicosAcolhimentoPendencias() {
    return axios.get(API + path + "/pendencias");
  }

  listarPendentes(id) {
    return axios.get(API + path + `/${id}/registros`);
  }

  suspenderSA(id, dados) {
    return axios.post(API + path + `/${id}/suspender`, dados);
  }

  desativarSA(id, dados) {
    return axios.post(API + path + `/${id}/desativar`, dados);
  }

  reativarSA(id, dados) {
    return axios.post(API + path + `/${id}/reativar`, dados);
  }

  dadosImpressao(id) {
    return axios.get(API + path + `/${id}/imprimir`);
  }

  getServicosAcolhimentoAtivosSuspensos() {
    return axios.get(API + path + "/ativos-suspensos");
  }
  getServicosAcolhimentoAtivosSuspensosLogado() {
    return axios.get(API + path + "/ativos-suspensos-logado");
  }
  getServicosAcolhimentoCrianca(idCrianca, dataVisita) {
    return axios.get(
      API + path + `/crianca-visita/${idCrianca}?dataVisita=${dataVisita}`,
    );
  }

  getOrgaoExternoConselho(idConselhoTutelar) {
    return axios.get(API + path + `/conselho-tutelar/${idConselhoTutelar}`);
  }

  getPendenciasServico(idServicosAcolhimento) {
    return axios.get(
      API + path + `/${idServicosAcolhimento}/pendencias/ativas`,
    );
  }

  getPendenciaServicoDownload(idServicosAcolhimento) {
    return axios.get(API + path + `/${idServicosAcolhimento}/pendencias/excel`, {
      responseType: "blob",
    });
  }

  getProgramaApadrinhamentoServico(idServicosAcolhimento) {
    return axios.get(
      API + path + `/${idServicosAcolhimento}/programa-apadrinhamento`,
    );
  }

  postProgramaApadrinhamentoServico(
    idServicosAcolhimento,
    programaApadrinhamentoRequestDTO,
  ) {
    return axios.post(
      API + path + `/${idServicosAcolhimento}/programa-apadrinhamento`,
      programaApadrinhamentoRequestDTO,
    );
  }

  putProgramaApadrinhamentoServico(
    idServicosAcolhimento,
    programaApadrinhamentoRequestDTO,
  ) {
    return axios.put(
      API + path + `/${idServicosAcolhimento}/programa-apadrinhamento`,
      programaApadrinhamentoRequestDTO,
    );
  }
}

const instanceServicoAcolhimento = new ServicoAcolhimentoService();
export default instanceServicoAcolhimento;
